module.exports = __webpack_public_path__ + "img/3b91a13.jpg";